import React, { FC, useEffect } from 'react';
import Carusel from './components/Carusel';
import { ICard } from '../../../types/summary';
import gtmTrack from '../../../services/googleTagManager/track';
import { useDispatch, useSelector } from 'react-redux';
import { selectedBiteSelector } from '../../../store/bite/bite.selectors';
import useQueryParams from '../../../hooks/useQueryParams';
import { log } from '../../../store/tracking/tracking.slice';

interface IProps {
  cards: ICard[];
  summaryTranslations: string[];
  hasDiscussion: boolean;
}

const Summary: FC<IProps> = ({ cards, summaryTranslations, hasDiscussion }) => {
  const dispatch = useDispatch();
  const { queryParams } = useQueryParams();
  const playlistId = queryParams?.playlistId;

  const { selectedBite } = useSelector(selectedBiteSelector);

  useEffect(() => {
    gtmTrack('summary_section', {
      bite_id: selectedBite?.bite,
      bite_share_id: selectedBite?.id,
      content_org_id: selectedBite?.orgid,
      sharing_mode: selectedBite?.sharing_mode,
      playlist_id: playlistId,
    });

    return () => {
      dispatch(
        log({
          event: 'Summary: unmount',
          data: {
            biteShareId: selectedBite?.id,
          },
        }),
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playlistId, selectedBite]);

  return <Carusel cards={cards} summaryTranslations={summaryTranslations} hasDiscussion={hasDiscussion} />;
};

export default React.memo(Summary);
